export default {
  namespaced: true,

  state: {
    info: [
        {
            "tag": "instance",
            "link": "/",
            "tutCategory": "https://cyso.cloud/docs/cloud/getting-started/#configure-secure-access-for-instances",
            "content": {
                "1": "Higly scalable Instances (Servers / Virtual Machines). You only pay (per hour) for resources you actually need, without a setup fee or a minimum spending amount.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/getting-started/",
                    "title": "Getting Started",
                    "description": "Follow this guide to learn the basics.",
                },
                {
                    "href": "https://cyso.cloud/docs/cloud/compute/adding-keypairs-using-cli/",
                    "title": "OpenStack CLI",
                    "description": "Learn the basics of the OpenStack CLI",
                },
                {
                    "href": "https://cyso.cloud/docs/cloud/extra/how-to-use-ansible-to-deploy-an-instance-as-a-lamp-server-for-ubuntu-20-04/",
                    "title": "Ansible and Cyso Cloud",
                    "description": "Simple IT Automation",
                }
            ]
        },
        {
            "tag": "cluster",
            "content": {
                "1": "Create and operate clusters of homogeneous objects. This way you can orchestrate collections of similar objects more easily.",
            }
        },
        {
            "tag": "container",
            "content": {
                "1": "Run application containers without the need to manage servers or clusters.",
            }
        },
        {
            "tag": "kubernetes",
            "link": "/services/managed-kubernetes/",
            "content": {
                "1": "Create a cost-effective, ready-to-use Kubernetes cluster in minutes so you can focus on building your application.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/create-kubernetes-cluster-with-openstack-magnum",
                    "title": "Create a Kubernetes cluster",
                    "description": "with the OpenStack CLI and Magnum.",
                },
            ]
        },
        {
            "tag": "emk",
            "link": "/services/managed-kubernetes/",
            "content": {
                "1": "Create a cost-effective, ready-to-use Kubernetes cluster in minutes so you can focus on building your application.",
                "2": "Cluster Autoscaler is a tool that automatically adjusts the size of the Kubernetes cluster.",
                "3": "General-purpose web UI for Kubernetes clusters. Several high-profile attacks have shown weaknesses, so installation is not recommended, especially not for production clusters.",
                "4": "Default ingress-controller. Alternatively you may install any other ingress-controller of your liking. If you select this option please note that Cyso Cloud will include it in its reconciliation and you can't override it's configuration.",
                "5": "After creation of a shoot cluster, you need a kubeconfig to access it. For proper security it is recommended to use a dynamic token in the kubeconfig. See tutorial on docs.cyso.cloud on how to manage that.",
                "6": "The current Kubernetes version. The label color is as follows: green (cluster is fully up-to-date), yellow (update to a newer patch version with one arrow or to a minor version if you see the icon with the two arrows), red (your version has an expiration date) and blue (you can update to a preview version). Preview versions are not fully tested.",
                "7": "The Kubernetes cluster control plane is managed by Cyso Cloud (as pods in separate infrastructure clusters to which you have no direct access) and can be set up with no failure tolerance (control plane pods will be recreated best-effort when resources are available) or failure tolerance type zone.",
                "8": "Readiness: Cluster conditions are health indicators that show whether key parts of a Kubernetes cluster (like the API server, control plane, and nodes) are working properly. They help you quickly see if the cluster is healthy, progressing, or has issues.",
                "9": "Cluster purpose defines what the cluster is used for. Like production, testing or evaluation. It controls settings such as monitoring, add-ons, and how critical components behave to match the cluster's intended role.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/enterprise-managed-kubernetes/getting-started-with-the-emk-dashboard/",
                    "title": "Getting Started",
                    "description": " with Managed Kubernetes",
                },
                {
                    "href": "https://cyso.cloud/docs/enterprise-managed-kubernetes/how-to-access-my-emk-cluster/",
                    "title": "How to access cluster",
                    "description": "Learn how to access your cluster",
                },
                {
                    "href": "https://cyso.cloud/docs/enterprise-managed-kubernetes/cluster-actions/provisioning/",
                    "title": "Cluster Actions",
                    "description": "Awesome functions to manage your cluster",
                },
            ]
        },
        {
            "tag": "gardenerPagesAccounts",
            "content": {
                "1": "Adding service accounts to your project allows you to automate processes in your project. Access to resources within your project can be configured by assigning roles.",
                "2": "Admin - Access to all resources of this project, except for member management. Use the Service Account Manager role instead.",
                "3": "Viewer - Read access to project details and shoots. Has access to shoots but is not able to create new ones. Cannot read cloud provider secrets.",
                "4": "UAM - Give the member User Access Management rights. Members with this role can manage members, should be used in combination with admin role to extend rights. In case an external UAM system is connected via a service account, only this account should get the UAM role.",
                "5": "Service Account Manager - Manage service accounts inside the project namespace and request tokens for them. For security reasons this role should not be assigned to service accounts, especially it should be prevented that a service account can refresh tokens for itself.",
            },
        },
        {
            "tag": "gardenerPagesSecrets",
            "content": {
                "1": "Before you can provision and access a Kubernetes cluster on Cyso Cloud, you need to add account credentials. EMK needs the credentials to provision and operate the Cyso Cloud infrastructure for your Kubernetes cluster.",
            },
        },
        {
            "tag": "object-store",
            // "link": "/",
            "content": {
                "1": "The Object Store is suitable as a low-cost storage, for example: pictures, videos, and backups.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/object-storage/how-to-migrate-your-objectstore-to-cyso-cloud/",
                    "title": "How to migrate your Object Store to the Cyso Cloud Object Store",
                    "description": "Do you want to migrate to Cyso Cloud?",
                },
                {
                    "href": "https://cyso.cloud/docs/how-to-connect-to-the-fuga-cloud-objectstore",
                    "title": "How to connect to the Cyso Cloud Object Store",
                    "description": "With your API key you can connect to the Object Store",
                },
            ]
        },
        {
            "tag": "volume-store",
            // "link": "/",
            "content": {
                "1": "A volume is a detachable block storage device similar to a USB hard drive. You can attach a volume to an instance, and if the volume is of an appropriate volume type, a volume can be attached to multiple instances.",
                "2": "Tier-1 is  ideal for storing large amounts of data without any particular performance requirements. Tier-2 volumes can be used to meet needs where storage must be accompanied by high read and write performance. The tiers with 'm' are multi attached volumes.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/volume/how-to-attach-a-volume-to-your-instance/",
                    "title": "How to attach a Volume to your Instance",
                    "description": "Learn how to attach a volume to your instance",
                },
                {
                    "href": "https://cyso.cloud/docs/how-to-create-and-restore-a-volume-snapshot",
                    "title": "How to create and restore a Volume Snapshot",
                    "description": "Learn how to create and restore a Volume Snapshot",
                },
            ]
        },
        {
            "tag": "file-store",
            "content": {
                "1": "Data is stored as a single piece of information inside a folder, just like you’d organize pieces of paper inside a manila folder.",
            }
        },
        {
            "tag": "images",
            // "link": "/storage/",
            "content": {
                "1": "In addition to the standard OS images, you can also create images yourself. These will then end up nicely in your own catalog so that you can also deploy them with one click.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/compute/how-to-upload-and-use-custom-images/",
                    "title": "How to upload",
                    "description": " and use custom images",
                },
                {
                    "href": "https://cyso.cloud/docs/cloud/compute/how-to-create-a-cyso-cloud-instance-from-an-image/",
                    "title": "How to create an Instance from an Image",
                    "description": "Launch an instance with an image as boot source",
                },
            ]
        },
        {
            "tag": "snapshot",
            // "link": "/storage/",
            "content": {
                "1": "A snapshot is a point-in-time copy of the data that a volume contains. You can restore a snapshot by selecting it on the create instance as a boot source or create a new volume of the snapshot and connect it to an instance.",
            }
        },
        {
            "tag": "network-topo",
            // "link": "/networking/",
            "content": {
                "1": "Cyso Cloud offers advanced networking functionality for your cloud environment. Our network is completely redundant and has super-fast connections. Security Groups and internal networks ensure the right separation.",
            }
        },
        {
            "tag": "networks",
            // "link": "/networking/",
            "content": {
                "1": "Cyso Cloud offers advanced networking functionality for your cloud environment. Our network is completely redundant and has super-fast connections. Security Groups and internal networks ensure the right separation.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-create-and-manage-networks/",
                    "title": "How to create and manage networks",
                    "description": "OpenStack's network service provides an easy system for managing the network connectivity within Cyso Cloud.",
                },
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-create-and-configure-a-load-balancer/",
                    "title": "How to create and configure a load balancer",
                    "description": "Learn how to create and configure a load balancer",
                },
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-create-a-router-in-the-fuga-dashboard/",
                    "title": "How to create a router",
                    "description": "Learn how to create a router in the portal",
                },
            ]
        },
        {
            "tag": "port",
            // "link": "/networking/",
            "content": {
                "1": "A port is a connection point for attaching a single device, such as the NIC of a server, to a network. The port also describes the associated network configuration, such as the MAC and IP addresses to be used on that port.",
            }
        },
        {
            "tag": "router",
            // "link": "/networking/",
            "content": {
                "1": "A router is a logical component that forwards data packets between networks. It also provides Layer 3 and NAT forwarding to provide external network access for servers on project networks.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-create-a-router-in-the-fuga-dashboard/",
                    "title": "How to create a router",
                    "description": "Learn how to create a router in the portal",
                },
            ]
        },
        {
            "tag": "ip-addresses",
            // "link": "/networking/",
            "content": {
                "1": "A (Floating) IP, external IP, is a static IP address that can point to one of your instances. In other words, it allows you to redirect network traffic to any one of your instances.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-return-a-floating-ip/",
                    "title": "How to return a Floating IP",
                    "description": "When you no longer need a floating IP address, you can return it to the pool.",
                },
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-directly-attach-an-ipv4-or-ipv6-address-to-my-instance/",
                    "title": "How to directly attach an IPv4 or IPv6 address to my instance",
                    "description": "Cyso Cloud offers floating IPs and direct-attached IP addresses so your instances are remotely available for public networks (internet).",
                },
            ]
        },
        {
            "tag": "security-groups",
            // "link": "/networking/",
            "content": {
                "1": "All network ports are closed by default. With Security Groups, you can adjust which ports you want to open.",
                "2": "Security groups are sets of IP filter rules that are applied to network interfaces of an instance. After creation you can add rules to the security group.",
                "3": "Our advice is to not edit the default security group. If you want to add some extra rules, put them in a new Security Group."
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-use-security-groups-to-tighten-security/",
                    "title": "How to use Security Groups to tighten security",
                    "description": "Learn how to use Security Groups to tighten security",
                },
            ]
        },
        {
            "tag": "load-balancer",
            // "link": "/load-balancer/",
            "content": {
                "1": "Load Balancers let you distribute traffic between multiple Instances and are a good way to horizontally scale your app.",
            },
            "tutorials": [
                {
                    "href": "https://cyso.cloud/docs/cloud/networking/how-to-create-and-configure-a-load-balancer/",
                    "title": "How to create and configure a load balancer",
                    "description": "Learn how to create and configure a load balancer",
                },
            ]
        },
        {
            "tag": "dns",
            "content": {
                "1": "Connect to your websites using domain names instead of IP addresses.",
                "2": "PTR records provide a reverse mapping from a single IP or set of IP addresses to a domain.",
            }
        },
        {
            "tag": "databases",
            "content": {
                "1": "We manage the database engines for your applications so you can focus on building.",
            }
        },
        {
            "tag": "backups",
            "content": {
                "1": "Efficiency and flexibility for block based backups, file based incremental backups, point-in-time actions, jobs synchronization (i.e. backup synchronization over multiple nodes).",
            }
        },
        {
            "tag": "key-pairs",
            "content": {
                "1": "Before you can log into one of your instances via SSH, you need to create an SSH key pair.",
            },
            "tutorials": [
                {
                    "href": "https://docs.cyso.cloud/how-to-manage-your-ssh-keys-in-the-fuga-cloud-dashboard",
                    "title": "How to manage your SSH Keys on OpenStack",
                    "description": "This quick tutorial will show you how you can create or import an SSH key.",
                },
                {
                    "href": "https://docs.cyso.cloud/how-to-add-extra-ssh-key-pairs-to-an-instance",
                    "title": "How to add extra SSH Key Pairs to an Instance",
                    "description": "This tutorial will explain how to add extra SSH Key Pairs to your instance.",
                },
                {
                    "href": "https://docs.cyso.cloud/adding-keypairs-using-cli",
                    "title": "How to add a SSH Key Pair that can be used with the CLI",
                    "description": "Learn how to add a SSH Key Pair via the CLI.",
                },
            ]
        },
        {
            "tag": "app-credential",
            "content": {
                "1": "Application credentials are connected to your user account. Other team members can't use and see them.",
                "2": "Application credentials provide a way to delegate a user’s authorization to an application without sharing the user’s password authentication.",
                "3": "When creating a new App credential you can set some extra settings. It is best practive to set a expiry date on your credential. When you leave it blank the credential will not expire.",
                "4": "You can also create a secret on your own. You can simple add a string.",
            }
        },
        {
            "tag": "access-rules",
            "content": {
                "1": "Access rules are fine-grained permissions for application credentials. An access rule comprises of a service type, a request path, and a request method.",
                "2": "Access rules may only be created as attributes of application credentials, but they may be viewed and deleted independently.",
            }
        },
        {
            "tag": "ec-credential",
            "content": {
                "1": "EC2 / S3 credentials that are used on the Amazon S3 and Elastic Compute Cloud (EC2) APIs are different from the credentials that are used by the OpenStack API. As a result, you need to generate EC2 / S3 credentials.",
            }
        },
        {
            "tag": "team-credential",
            // "link": "/teams/",
            "content": {
                "1": "Team credentials are connected to a special designed user who is part of your team so your team members can all see and use them.",
                "2": "You can create EC2/S3 credentials connected to your Team Credentials so your whole team can see and use them.",
            }
        },
        {
            "tag": "secret",
            "content": {
                "1": "Cyso Cloud Secret Store is designed for the secure storage, provisioning and management of secrets such as passwords, encryption keys and X.509 Certificates.",
            }
        },
        {
            "tag": "billing",
            "content": {
                "1": "To pay for your use of Fuga resources, you can choose Credit Card or SEPA Direct Debit.",
                "2": "Credits are updated after payments every month.",
                "3": "Use credits to pay your resources.",
            }
        },
        {
            "tag": "team",
            // "link": "/teams/",
            "content": {
                "1": "With teams, you have completely separate cloud environments in which to manage projects and users.",
                "2": "Right now, you only have one project on a team. If you need more projects, you can create a new team.",
                "3": "You can invite users to join your team. Please note that the email address must be identical to the email address that is used during the invitee's registration.",
            }
        },
        {
            "tag": "volume-backup",
            // "link": "/volume-backup/",
            "content": {
                "1": "A disk or volume backup stores a disk or a volume file system as a whole and includes all of the information necessary for the operating system to boot.",
            }
        },
        ]
    },
}
